<template>
  <div class="vd-gl-content">
    <!-- 检索条件 -->
    <a-row class="vd-toolbar">
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-button type="primary" icon="plus" @click="createActive">
              新增活动
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table
      :data-source="list"
      :pagination="pagination"
      row-key="id"
      size="small"
    >
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="活动" data-index="name" />
      <a-table-column title="项目类型" data-index="category_name" />
      <a-table-column title="备注" data-index="remark" />
      <a-table-column title="操作" align="center">
        <template slot-scope="record">
          <a-tooltip title="修改">
            <a-icon class="common-icon" type="edit" @click="modify(record)" />
          </a-tooltip>
          <a-tooltip title="详情">
            <a-icon
              class="common-icon"
              type="ellipsis"
              @click="detail(record)"
            />
          </a-tooltip>
        </template>
      </a-table-column>
    </a-table>

    <a-modal
      :visible="visible"
      okText="提交"
      cancelText="取消"
      @ok="_ok"
      @cancel="_cancel"
      :title="form.id === undefined ? '发布' : '修改'"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="活动名称" prop="name">
          <a-input
            class="vd-input-s"
            placeholder="活动名称 20 字以内"
            v-model="form.name"
          />
          <span style="color: #999999;font-size: 10px">
            {{ form.name.length }}/20</span
          >
        </a-form-model-item>

        <a-form-model-item label="项目类型" prop="category">
          <a-select
            style="width: 216px"
            v-model="form.category"
            placeholder="请选择项目类型"
          >
            <template v-for="item in subList">
              <a-select-option :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            class="vd-input-s"
            placeholder="活动备注 50 字以内"
            v-model="form.remark"
          ></a-textarea>
          <span style="color: #999999;font-size: 10px">
            {{ form.remark.length }}/50</span
          >
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { modify_active, get_active } from '@/api/book'

export default {
  name: 'Activity',
  data() {
    return {
      visible: false,
      form: {
        id: undefined,
        name: '',
        remark: '',
        category: undefined,
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 9,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      rules: {
        name: [
          { required: true, message: '请填写活动名称', trigger: 'blur' },
          { max: 20, message: '名称限20字以内', trigger: 'change' },
        ],
        category: [
          { required: true, message: '请选择项目类型', trigger: 'blur' },
        ],
        remark: [{ max: 50, message: '备注限50字以内', trigger: 'change' }],
      },
      list: [],
      subList: [],
    }
  },
  mounted() {
    this.getData()
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
  },
  methods: {
    getData() {
      get_active({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        }
      })
    },
    createActive() {
      this.visible = !this.visible
      this.form.id = undefined
    },
    _ok() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify_active(this.form).then((res) => {
            if (res.code === 1) {
              this.visible = !this.visible
              this.form.name = this.form.remark = ''
              this.form.id = 0
              this.getData()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    _cancel() {
      this.visible = !this.visible
      this.form.name = this.form.remark = ''
      this.form.id = this.form.category = undefined
    },
    modify(item) {
      this.visible = !this.visible

      this.form.name = item.name
      this.form.remark = item.remark
      this.form.category = item.category
      this.form.id = item.id
    },
    detail(item) {
      this.$router.push({ path: '/book/detail', query: { id: item.id } })
    },
  },
}
</script>

<style scoped></style>
